import { render, staticRenderFns } from "./projectItem.vue?vue&type=template&id=4a91a617&scoped=true"
import script from "./projectItem.vue?vue&type=script&lang=ts"
export * from "./projectItem.vue?vue&type=script&lang=ts"
import style0 from "./projectItem.vue?vue&type=style&index=0&id=4a91a617&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_3bbe12a2a332147dfeceaba3e069e538/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a91a617",
  null
  
)

export default component.exports